module.exports = __webpack_public_path__ + "static/img/09qinqin.85b459c9.gif";